<script>
import TileLayer from "ol/layer/WebGLTile.js";
import { Vector as VectorSource } from "ol/source";
import { getVectorContext } from "ol/render";
import GeoJSON from "ol/format/GeoJSON";
import parseStyle from "../ol-map/utils/style";
import GeoTIFF from "ol/source/GeoTIFF";
let olMap = null;

export default {
  name: "ol-layer-geotile",

  inject: ["getMap"],

  render() {
    return this.$slots.default;
  },

  provide() {
    return {
      getLayer: this.getLayer,
    };
  },

  props: {
    // 图层名称
    name: {
      type: String,
      default: "",
    },

    // 图层类型
    type: {
      type: String,
      default: "",
    },

    // 是否可见
    visible: {
      type: Boolean,
      default: true,
    },

    // 透明度（0~1）
    opacity: {
      type: Number,
      default: 1,
    },

    // 层级
    zIndex: {
      type: Number,
      default: undefined,
    },

    // 预加载（Infinity / 0）
    preload: {
      type: Number,
      default: 0,
    },

    // 裁切边界
    clip: {
      type: String,
      default: "",
    },
  },

  watch: {},

  data() {
    return {
      tileLayer: null,
      clipLayer: null,
    };
  },

  created() {


    // 配色规则
    const colorList = [
      { labelText: "0.0", color: "#0df503" },
      { labelText: "0.25", color: "#9df700" },
      { labelText: "0.5", color: "#f7e100" },
      { labelText: "0.75", color: "#fc6c00" },
      { labelText: "1.0", color: "#f50000" },
    ];

    // 生成颜色表达式
    const generateColorExpression = (colorList) => {
      const cases = [];
      for (let i = 0; i < colorList.length - 1; i++) {
        const current = colorList[i];
        const next = colorList[i + 1];
        const value = parseFloat(current.labelText);
        const nextValue = parseFloat(next.labelText);

        const [r1, g1, b1] = [
          parseInt(current.color.substring(1, 3), 16) / 255,
          parseInt(current.color.substring(3, 5), 16) / 255,
          parseInt(current.color.substring(5, 7), 16) / 255,
        ];

        const [r2, g2, b2] = [
          parseInt(next.color.substring(1, 3), 16) / 255,
          parseInt(next.color.substring(3, 5), 16) / 255,
          parseInt(next.color.substring(5, 7), 16) / 255,
        ];

        // 插值表达式
        cases.push(["<=", ["var", "value"], nextValue, [r2, g2, b2, 1]]);
        cases.push(["<=", ["var", "value"], value, [r1, g1, b1, 1]]);
      }
      return ["case", ...cases, [0, 0, 0, 0]]; // 默认值（透明）
    };

    // 数据范围
    const minValue = 0.192;
    const maxValue = 0.582;
    const noDataValue = -3.4028230607370965e38;
    const colorExpression = generateColorExpression(colorList);
    const source = new GeoTIFF({
      sources: [
        // {
        //   url: "https://s2downloads.eox.at/demo/EOxCloudless/2020/rgbnir/s2cloudless2020-16bits_sinlge-file_z0-4.tif",

        // },
        // {
        //   url: "https://s2downloads.eox.at/demo/Sentinel-2/3857/R10m.tif",
        //   bands: [3, 4],
        //   min: 0,
        //   nodata: 0,
        //   max: 65535,
        // },
        // {
        //   url: "https://s2downloads.eox.at/demo/Sentinel-2/3857/R60m.tif",
        //   bands: [9],
        //   min: 0,
        //   nodata: 0,
        //   max: 65535,
        // },
        {
          // url:'http://152.136.235.43:8080/geoserver/henan/wms?SERVICE=WMS&VERSION=1.1.0&REQUEST=GetMap&FORMAT=image%2Fpng&TRANSPARENT=true&layers=henan%3Aly_603_9999_3104000813_20240522_tif&WIDTH=256&HEIGHT=256&SRS=EPSG%3A4326&BBOX=114.752197265625%2C34.771728515625%2C114.76318359375%2C34.78271484375',
          // url:'http://152.136.235.43:8080/geoserver/henan/ows?service=WCS&version=1.1.0&request=GetCoverage&coverageId=henan:ly_603_9999_3104000813_20240522_tif',
          //url:'http://152.136.235.43:8080/geoserver/henan/ows?service=WCS&version=1.1.0&request=GetCoverage&coverageId=henan:ly_603_9999_3104000813_20240522_tif&format=image/tiff',
          url: "data/LAI.tif",
        },
      ],
    });
    const ndvi = [
      "/",
      ["-", ["band", 2], ["band", 1]],
      ["+", ["band", 2], ["band", 1]],
    ];

    const ndwi = [
      "/",
      ["-", ["band", 3], ["band", 1]],
      ["+", ["band", 3], ["band", 1]],
    ];
    console.log("colorExpression", colorExpression);

    this.tileLayer = new TileLayer({
      style: {
        variables: {
          // 归一化到 [0, 1]
          value: ["/", ["-", ["band", 1], minValue], ["-", maxValue, minValue]],
        },
        // 剔除无效值并应用颜色表达式
        color: [
          "case",
          ["==", ["band", 1], noDataValue],
          [0, 0, 0, 0], // 无效值透明
          ...colorExpression, // 应用配色规则
        ],
      },
      source,
    });

    this.getMap((map) => {
      olMap = map;
      map.addLayer(this.tileLayer);
    });
  },

  methods: {
    // 获取组件实例
    getLayer(cb) {
      cb(this.tileLayer);
    },
    setLayerFilterClip(layer, feature) {
      layer.on("prerender", (event) => {
        let vectorContext = getVectorContext(event);
        event.context.globalCompositeOperation = "source-over";
        let ctx = event.context;
        ctx.save();
        vectorContext.drawFeature(
          feature,
          parseStyle({ fill: { color: "transparent" } })
        );
        ctx.clip();
      });
      layer.on("postrender", (event) => {
        let ctx = event.context;
        ctx.restore();
      });
      layer.setExtent(feature.getGeometry().getExtent());
    },

    addfeatureHandle() {
      // this.tileLayer.setExtent(this.clipLayer.getSource().getExtent());
    },

    postrenderHandle(e) {
      const vectorContext = getVectorContext(e);
      e.context.globalCompositeOperation = "destination-in";
      this.clipLayer.getSource().forEachFeature((feature) => {
        vectorContext.drawFeature(
          feature,
          parseStyle({ fill: { color: "transparent" } })
        );
      });
      e.context.globalCompositeOperation = "source-over";
    },
  },

  beforeDestroy() {},
};
</script>
